import { useState, useEffect } from "react";

const talents = [
  {
    name: "ふるせくん",
    role: "社長",
    attr: "ワキガ",
    attrColor: "#FF0F0F",
    attrBg: "bg-[#FF0F0F]",
    emoji: "👑",
    power: 72,
    speed: 45,
    charisma: 88,
    desc: "モテたくて常にダイエットをしている。ダイエットと清潔感を効率よく得ようとして、風呂で体毛を剃り、同時にシャドーボクシングをする。風呂場が毛まみれになり、嫁に激怒される。",
    skills: ["社長です", "成形肉", "毛の除去"],
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/379ddbd0f5dbb9a2145b2b4cba60988b.jpeg",
    borderColor: "border-[#FF0F0F]",
    glowColor: "rgba(255,15,15,0.4)",
    frameColor: "#FF0F0F",
    videoUrl: "https://youtu.be/d8JeOmb_czI?si=GACIYD8CZfJ1wSX-",
    videoId: "d8JeOmb_czI",
  },
  {
    name: "水野さん",
    role: "ベテラン4トンドライバー",
    attr: "皆の人気者",
    attrColor: "#0066FF",
    attrBg: "bg-[#0066FF]",
    emoji: "🍜",
    power: 95,
    speed: 68,
    charisma: 97,
    desc: "血圧がここには書けないくらい高く、いつも目が血走っている。ラーメンをこよなく愛し、スープは完飲派。店への礼儀だと言い張る。絶対にただ飲みたいだけ。",
    skills: ["ラーメン完飲", "人気者オーラ", "血圧MAX"],
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/b154f508f5d9f960b74b7c5ec53f6def.png",
    borderColor: "border-[#0066FF]",
    glowColor: "rgba(0,102,255,0.4)",
    frameColor: "#0066FF",
    videoUrl: "https://youtu.be/0d6bR_HHs78?si=dTTzlLfyn5e5Zdbx",
    videoId: "0d6bR_HHs78",
  },
  {
    name: "さくやくん",
    role: "チェリードライバー",
    attr: "鉄オタ",
    attrColor: "#7C3AED",
    attrBg: "bg-purple-600",
    emoji: "🚃",
    power: 55,
    speed: 78,
    charisma: 62,
    desc: "何かはここには書けないが、水野さんの影響で無理やり大人の階段を登らされ、今では取り返しのつかない状態になっている。もっとお金を大切にして欲しい。",
    skills: ["鉄道知識MAX", "水野さん影響下", "回復不能状態"],
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/e7520f6ffd5e7728e501b2af1c6296c2.png",
    borderColor: "border-purple-500",
    glowColor: "rgba(124,58,237,0.4)",
    frameColor: "#7C3AED",
    videoUrl: "https://www.youtube.com/watch?v=R7rqX7rT7FI&list=PLEvleHvb7Eg_SkqbycvPtS0CpDNbxuNl5",
    videoId: "R7rqX7rT7FI",
  },
  {
    name: "たまきさん",
    role: "事務員さん",
    attr: "ノリは良い",
    attrColor: "#F59E0B",
    attrBg: "bg-amber-500",
    emoji: "📋",
    power: 30,
    speed: 85,
    charisma: 90,
    desc: "トラックのことをほとんど知らない事務員さん。ウイングのことを「サプライズボックス」と言い、「トラックにハザードはない」と言い切る。",
    skills: ["天然", "ノリの良さ", "トラック知識0"],
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/9dea1a884d951846d5231a905f646b82.png",
    borderColor: "border-amber-500",
    glowColor: "rgba(245,158,11,0.4)",
    frameColor: "#F59E0B",
    videoUrl: "https://youtu.be/_BLSTG6sFv4?si=8jy9SaQygoZOyGWa",
    videoId: "_BLSTG6sFv4",
  },
  {
    name: "ほまちゃん",
    role: "ゲイのトラックドライバー",
    attr: "恋多き乙女",
    attrColor: "#EC4899",
    attrBg: "bg-pink-500",
    emoji: "💕",
    power: 65,
    speed: 70,
    charisma: 99,
    desc: "ゲイだとカミングアウトして働いている。動きと喋り方がオバさんみたい。プライベートが充実しているととても機嫌が良い。逆もまた然り。",
    skills: ["バニラ", "機嫌のバロメーター", "乙女ムーブ"],
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/1881620fb692ebeefdae4c0e662af1e0.png",
    borderColor: "border-pink-500",
    glowColor: "rgba(236,72,153,0.4)",
    frameColor: "#EC4899",
    videoUrl: "https://youtu.be/nkU9MusUFXQ?si=gMrNodLGwBr-mG7Y",
    videoId: "nkU9MusUFXQ",
  },
];

function StatBar({ label, value, color }: { label: string; value: number; color: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-black text-gray-500 w-16 shrink-0">{label}</span>
      <div className="flex-1 bg-gray-100 rounded-full h-2 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-700"
          style={{ width: `${value}%`, background: color }}
        />
      </div>
      <span className="text-xs font-black w-6 text-right" style={{ color }}>{value}</span>
    </div>
  );
}

function useScrollAnim() {
  useEffect(() => {
    const els = document.querySelectorAll(".anim-fade-up, .anim-fade-left, .anim-fade-right, .anim-scale-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function TalentGallery() {
  const [selected, setSelected] = useState<number | null>(null);
  useScrollAnim();

  // モーダルを開いたときにスクロールを無効化
  useEffect(() => {
    if (selected !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [selected]);

  return (
    <section id="talent" className="py-20 bg-black relative overflow-hidden">
      {/* BG grid pattern */}
      <div className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: "linear-gradient(#00B050 1px, transparent 1px), linear-gradient(90deg, #00B050 1px, transparent 1px)",
          backgroundSize: "40px 40px"
        }}
      />
      {/* Floating accent image */}
      <img
        src="https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/eafff15e-0a13-403d-9960-50150c54d396_unnamed.png?v=896eb9540baf0220bacf714d5166a7fc"
        alt=""
        className="absolute top-10 left-4 w-24 md:w-36 opacity-70 pointer-events-none z-10 animate-float"
        style={{ "--rot": "6deg" } as React.CSSProperties}
      />
      {/* Color accent top */}
      <div className="absolute top-0 left-0 right-0 h-2 flex">
        <div className="flex-1 bg-[#FF0F0F]" />
        <div className="flex-1 bg-[#FFD700]" />
        <div className="flex-1 bg-[#0066FF]" />
        <div className="flex-1 bg-[#00B050]" />
        <div className="flex-1 bg-[#EC4899]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 anim-fade-up">
          <div className="inline-block bg-[#FFD700] text-black font-black text-sm px-6 py-2 rounded-full mb-4 tracking-widest border-4 border-white">
            CHARACTER SELECT
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white">
            愉快な出演<span className="text-[#FFD700]">タレント</span>
          </h2>
          <p className="text-gray-400 font-bold mt-2">キャラクターをクリックすると詳細が見られます</p>
          <div className="flex justify-center gap-2 mt-3 flex-wrap">
            <span className="text-[#00B050] font-black text-sm tracking-widest animate-pulse">▶ CLICK TO SELECT CHARACTER ◀</span>
          </div>
        </div>

        {/* Character cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {talents.map((talent, i) => (
            <div
              key={i}
              className={`relative cursor-pointer transition-all duration-300 hover:scale-105 hover:-translate-y-2 anim-scale-in anim-delay-${(i + 1) * 100}`}
              onClick={() => setSelected(i)}
            >
              {/* Card */}
              <div
                className={`border-4 ${talent.borderColor} rounded-2xl overflow-hidden bg-black card-shine`}
                style={{ boxShadow: `2px 2px 0px ${talent.frameColor}` }}
              >
                {/* Card top bar */}
                <div className="flex items-center justify-between px-3 py-1.5 bg-black border-b-2" style={{ borderColor: talent.frameColor }}>
                  <span className="text-white font-black text-xs tracking-widest">TRUCK BOYS</span>
                  <span className="text-lg animate-wiggle" style={{ animationDelay: `${i * 0.3}s` }}>{talent.emoji}</span>
                </div>

                {/* Image */}
                <div className="relative bg-gray-900" style={{ height: "200px" }}>
                  <img
                    src={talent.img}
                    alt={talent.name}
                    className="w-full h-full object-cover object-top"
                  />
                  {/* Attr badge */}
                  <div className="absolute bottom-2 left-2">
                    <div className={`${talent.attrBg} text-white font-black text-xs px-2 py-0.5 rounded-full border-2 border-white`}>
                      【{talent.attr}】
                    </div>
                  </div>
                  {/* Click hint */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity bg-black/40">
                    <div className="bg-[#FFD700] text-black font-black text-sm px-4 py-2 rounded-full border-4 border-black">
                      タップして詳細！
                    </div>
                  </div>
                </div>

                {/* Info */}
                <div className="p-3 bg-black">
                  <p className="text-gray-400 font-black text-xs mb-0.5">{talent.role}</p>
                  <p className="text-white font-black text-xl mb-2">{talent.name}</p>
                  <div className="space-y-1">
                    <StatBar label="POWER" value={talent.power} color={talent.frameColor} />
                    <StatBar label="SPEED" value={talent.speed} color={talent.frameColor} />
                    <StatBar label="CHARM" value={talent.charisma} color={talent.frameColor} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal overlay */}
      {selected !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8"
          style={{ background: "rgba(0,0,0,0.85)" }}
          onClick={() => setSelected(null)}
        >
          <div
            className="relative w-full max-w-3xl rounded-3xl overflow-hidden border-4 bg-black anim-scale-in is-visible"
            style={{
              borderColor: talents[selected].frameColor,
              boxShadow: `0 0 60px ${talents[selected].glowColor}, 0 0 0 8px ${talents[selected].frameColor}44`,
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal top bar */}
            <div className="flex items-center justify-between px-6 py-3 border-b-4" style={{ borderColor: talents[selected].frameColor, background: talents[selected].frameColor }}>
              <span className="text-white font-black text-lg tracking-widest">CHARACTER DETAIL</span>
              <button
                onClick={() => setSelected(null)}
                className="w-8 h-8 flex items-center justify-center bg-black rounded-full border-2 border-white text-white font-black cursor-pointer hover:bg-gray-800 transition-colors"
              >
                ✕
              </button>
            </div>

            <div className="p-6 md:p-8">
              <div className="flex flex-col md:flex-row gap-6 items-start">
                {/* Image */}
                <div className="w-full md:w-56 shrink-0">
                  <div className="border-4 rounded-2xl overflow-hidden" style={{ borderColor: talents[selected].frameColor }}>
                    <img
                      src={talents[selected].img}
                      alt={talents[selected].name}
                      className="w-full object-cover object-top"
                      style={{ height: "280px" }}
                    />
                  </div>
                  {/* Stats */}
                  <div className="mt-4 space-y-2">
                    <StatBar label="POWER" value={talents[selected].power} color={talents[selected].frameColor} />
                    <StatBar label="SPEED" value={talents[selected].speed} color={talents[selected].frameColor} />
                    <StatBar label="CHARM" value={talents[selected].charisma} color={talents[selected].frameColor} />
                  </div>
                </div>

                {/* Detail */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4 flex-wrap">
                    <span className="text-4xl animate-wiggle">{talents[selected].emoji}</span>
                    <div>
                      <p className="text-gray-400 font-black text-sm">{talents[selected].role}</p>
                      <h3 className="text-4xl font-black text-white">{talents[selected].name}</h3>
                    </div>
                  </div>
                  <div className={`${talents[selected].attrBg} text-white font-black text-lg px-4 py-2 rounded-full border-4 border-white inline-block mb-5`}>
                    属性：【{talents[selected].attr}】
                  </div>
                  <p className="text-gray-200 font-bold leading-relaxed text-base mb-6">
                    {talents[selected].desc}
                  </p>
                  <div className="mb-4">
                    <p className="text-gray-400 font-black text-xs mb-2 tracking-widest">SKILLS</p>
                    <div className="flex flex-wrap gap-2">
                      {talents[selected].skills.map((skill) => (
                        <span
                          key={skill}
                          className="font-black text-sm px-4 py-2 rounded-full border-2 text-white"
                          style={{ borderColor: talents[selected].frameColor, background: `${talents[selected].frameColor}33` }}
                        >
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* 代表動画 */}
                  <div className="mt-4">
                    <p className="text-gray-400 font-black text-xs mb-3 tracking-widest">FEATURED VIDEO</p>
                    <a
                      href={talents[selected].videoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block rounded-xl overflow-hidden border-2 cursor-pointer hover:opacity-90 transition-opacity"
                      style={{ borderColor: talents[selected].frameColor }}
                    >
                      <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                        <img
                          src={`https://img.youtube.com/vi/${talents[selected].videoId}/hqdefault.jpg`}
                          alt={`${talents[selected].name}の代表動画`}
                          className="absolute inset-0 w-full h-full object-cover"
                        />
                        {/* Play button overlay */}
                        <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                          <div
                            className="w-14 h-14 flex items-center justify-center rounded-full border-4 border-white animate-pulse-scale"
                            style={{ background: talents[selected].frameColor }}
                          >
                            <i className="ri-play-fill text-white text-2xl ml-1" />
                          </div>
                        </div>
                        {/* YouTube badge */}
                        <div className="absolute bottom-2 right-2 bg-black/80 text-white font-black text-xs px-2 py-1 rounded-md flex items-center gap-1">
                          <i className="ri-youtube-fill text-[#FF0000]" />
                          YouTube で見る
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              {/* Navigation */}
              <div className="mt-6 flex justify-between items-center border-t-2 pt-4" style={{ borderColor: talents[selected].frameColor + "44" }}>
                <button
                  onClick={() => setSelected(selected > 0 ? selected - 1 : talents.length - 1)}
                  className="flex items-center gap-2 text-white font-black px-4 py-2 rounded-full border-2 border-white cursor-pointer hover:bg-white/10 transition-colors whitespace-nowrap"
                >
                  ◀ 前のキャラ
                </button>
                <span className="text-gray-500 font-black text-sm">{selected + 1} / {talents.length}</span>
                <button
                  onClick={() => setSelected(selected < talents.length - 1 ? selected + 1 : 0)}
                  className="flex items-center gap-2 text-white font-black px-4 py-2 rounded-full border-2 border-white cursor-pointer hover:bg-white/10 transition-colors whitespace-nowrap"
                >
                  次のキャラ ▶
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
